// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3ycoM","savePackageButton":"ClientWallet_savePackageButton__3zCkz"};